// @flow
import {
    React, useEffect
} from 'react';
import IntakeWelcomeScreen from './IntakeWelcomeScreen';
import { useDispatch } from 'react-redux';
import { hideHeader } from '../../redux/actions/questionnaireActions';
import { useNavigate } from 'react-router-dom';

export default function IntakeCompletionWelcomeContainer(): React$Element<any> {
    const history = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(hideHeader(true));

        return dispatch(hideHeader(false));

        
    }, []);

    const onRedirect = () => {
        // main route automatically decides the path for dashboard based on role
        history('/');
    };

    return <IntakeWelcomeScreen onRedirect={onRedirect}/>;
}
